import styled from 'styled-components';

export const Card = styled.div`
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e9ecef;
  overflow: hidden;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  }
`;

export const CardContent = styled.div`
  display: flex;
  padding: 10px;
`;

export const ProfileSection = styled.div`
  flex-shrink: 0;
  width: 140px;
  height: 211px;
  overflow: hidden;

  
  .profile-image {
    width: 100%;
    object-fit: cover;
    height: 100%
  }
  
  @media (max-width: 768px) {
    width: 120px;
    height: 160px;
  }
`;

export const InfoSection = styled.div`
  flex: 1;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  
  .professional-name {
    font-size: 1.25rem;
    font-weight: 600;
    color: #807F7E;
    margin: 0 0 8px 0;
    font-family: 'Inter SemiBold';
  }
  
  .specialties {
    margin-bottom: 12px;
    
    .specialty {
      font-size: 0.875rem;
      color: var(--primary-color);
      font-weight: 500;
      font-family: 'Inter';
    }
    
    .separator {
      font-size: 0.875rem;
      color: var(--primary-color);
      font-weight: 500;
    }
  }
  
  .location {
    display: flex;
    align-items: center;
    gap: 6px;
     
    img {
      width: 14px;
      height: 14px;
    }
    
    span {
      font-size: 0.875rem;
      color: #6c757d;
      font-family: 'Inter Regular';
    }
  }
  
  @media (max-width: 768px) {
    padding: 16px;
    
    .professional-name {
      font-size: 1.125rem;
    }
  }
`;

export const ContactInfo = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
  align-items: center;
  padding: 10px 0px 15px 0px;

  svg {
    width: 20px;
    height: 20px;
    fill: red; 
    flex-shrink: 0;
  }

`;

export const ContactItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  transition: color 0.2s ease;
  text-decoration: none;
  
  img {
    width: 16px;
    height: 16px;
  }
  
  span {
    font-size: 0.75rem;
    color: #6c757d;
    font-family: 'Inter Regular';
  }
  
  &:hover span {
    color: var(--primary-color);
  }
`;

export const ReadBioButton = styled.button`
  background: linear-gradient(to right,#5E287E,#D82E88);
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 20px;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  align-self: flex-start;
  font-family: 'Inter';
  
 
  
  @media (max-width: 768px) {
    padding: 8px 16px;
    font-size: 0.8125rem;
  }
`;

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
`;

export const Modal = styled.div`
  background: white;
  border-radius: 12px;
  max-width: 600px;
  width: 100%;
  max-height: 80vh;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
  animation: modalSlideIn 0.3s ease-out;
  
  @keyframes modalSlideIn {
    from {
      opacity: 0;
      transform: scale(0.9) translateY(-20px);
    }
    to {
      opacity: 1;
      transform: scale(1) translateY(0);
    }
  }
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px;
  border-bottom: 1px solid #e9ecef;
  
  .modal-profile-section {
    display: flex;
    align-items: center;
    gap: 16px;
    
    .modal-profile-image {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      object-fit: cover;
    }
    
    .modal-info {
      h2 {
        font-size: 1.25rem;
        font-weight: 600;
        color: #2d3748;
        margin: 0 0 4px 0;
        font-family: 'Inter SemiBold';
      }
      
      .modal-specialties {
        font-size: 0.875rem;
        color: var(--primary-color);
        font-weight: 500;
        font-family: 'Inter';
      }
    }
  }
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 2rem;
  color: #6c757d;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s ease;
  
  &:hover {
    background: #f8f9fa;
    color: #495057;
  }
`;

export const ModalBody = styled.div`
  padding: 24px;
  overflow-y: auto;
  flex: 1;
  
  h3 {
    font-size: 1.125rem;
    font-weight: 600;
    color: #2d3748;
    margin: 0 0 16px 0;
    font-family: 'Inter SemiBold';
  }
  
  .biography-content {
    font-size: 0.875rem;
    line-height: 1.6;
    color: #495057;
    margin-bottom: 24px;
    font-family: 'Inter Regular';
    
    p {
      margin: 0 0 12px 0;
    }
  }
  
  .courses-section {
    margin-top: 24px;
    
    .courses-list {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
      margin-top: 12px;
      
      .course-tag {
        background: #f8f9fa;
        color: #495057;
        padding: 6px 12px;
        border-radius: 16px;
        font-size: 0.75rem;
        font-weight: 500;
        font-family: 'Inter';
        border: 1px solid #e9ecef;
      }
    }
  }
`;